(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["givana-pink-friday"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    if (root.dataset.pfInitialized === 'true') return;
    root.dataset.pfInitialized = 'true';
    const el = (name) => root.querySelector('[data-pf-' + name + ']');
    const startString = root.dataset.start || '';
    const validFormat = /^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:00\+(?:02|03):00$/.test(startString);
    const start = validFormat ? Date.parse(startString) : NaN;
    const hour = 3600000;
    const endFirst = start + hour;
    const endCampaign = start + 24 * hour;
    const messages = {
      before: root.dataset.before || '',
      first: root.dataset.first || '',
      rest: root.dataset.rest || '',
      ended: root.dataset.ended || ''
    };
    const bar = el('bar');
    const barText = el('bar-text');
    const barLink = el('bar-link');
    const apply = el('apply');
    const cta = el('cta');
    const originalShopPath = root.dataset.shopPath || '/collections/all';
    const originalShopUrl = new URL(originalShopPath, window.location.origin);
    const shopPath = originalShopUrl.pathname + originalShopUrl.search;
    const discountBase = root.dataset.discountBase || '/discount/';
    function discountUrl(code) {
      const prefix = discountBase.endsWith('/') ? discountBase : discountBase + '/';
      return prefix + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(shopPath);
    }
    let phase = '';
    const pad = (number) => String(number).padStart(2, '0');

    function update() {
      if (!Number.isFinite(start)) {
        el('message').textContent = 'Campaign date is not configured correctly.';
        el('clock').hidden = true;
        el('code-wrap').hidden = true;
        el('progress-wrap').hidden = true;
        if (bar) bar.hidden = true;
        if (apply) apply.hidden = true;
        return;
      }
      const now = Date.now();
      const nextPhase = now < start ? 'before' : now < endFirst ? 'first' : now < endCampaign ? 'rest' : 'ended';
      if (nextPhase !== phase) {
        phase = nextPhase;
        el('message').textContent = messages[phase];
        el('offer').hidden = phase === 'before' || phase === 'ended';
        el('offer').textContent = phase === 'first' ? root.dataset.offer15 : phase === 'rest' ? root.dataset.offer10 : '';
        el('code-wrap').hidden = phase === 'before' || phase === 'ended';
        el('code').textContent = phase === 'first' ? root.dataset.code15 : phase === 'rest' ? root.dataset.code10 : '';
        el('progress-wrap').hidden = phase === 'before' || phase === 'ended';
        el('clock').hidden = phase === 'ended';
        el('feedback').textContent = '';
        const active = phase === 'first' || phase === 'rest';
        const activeCode = phase === 'first' ? root.dataset.code15 : root.dataset.code10;
        const activeLink = active && activeCode ? discountUrl(activeCode) : shopPath;
        if (apply) {
          apply.hidden = !active || !activeCode;
          apply.href = activeLink;
        }
        if (cta) cta.href = activeLink;
        if (bar && barText) {
          const barMessage = phase === 'before' ? root.dataset.barBefore : phase === 'first' ? root.dataset.barFirst : phase === 'rest' ? root.dataset.barRest : root.dataset.barEnded;
          barText.textContent = barMessage || '';
          if (barLink) {
            barLink.hidden = !active || !activeCode;
            barLink.href = activeLink;
          }
        }
      }
      if (phase === 'ended') return;
      const target = phase === 'before' ? start : phase === 'first' ? endFirst : endCampaign;
      const remaining = Math.max(0, target - now);
      const seconds = Math.ceil(remaining / 1000);
      el('days').textContent = pad(Math.floor(seconds / 86400));
      el('hours').textContent = pad(Math.floor(seconds % 86400 / 3600));
      el('minutes').textContent = pad(Math.floor(seconds % 3600 / 60));
      el('seconds').textContent = pad(seconds % 60);
      if (phase === 'first' || phase === 'rest') {
        const duration = phase === 'first' ? hour : 23 * hour;
        el('progress').style.width = Math.min(100, Math.max(0, 100 * (1 - remaining / duration))) + '%';
      }
    }

    el('copy').addEventListener('click', async function () {
      const code = el('code').textContent;
      if (!code) return;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          const input = document.createElement('textarea');
          input.value = code;
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          const copied = document.execCommand('copy');
          input.remove();
          if (!copied) throw new Error('Copy failed');
        }
        el('feedback').textContent = 'Code copied!';
      } catch (error) {
        el('feedback').textContent = 'Please select and copy the code manually.';
      }
    });
    update();
    const timer = window.setInterval(function () {
      if (!root.isConnected) {
        clearInterval(timer);
        return;
      }
      update();
    }, 1000);
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('.givana-pf')) initialize(scope);
    scope.querySelectorAll('.givana-pf').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
